import { ReactNode } from "react";
import {
  CircularProgress,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";

export const MenuNavButton = ({
  handler,
  icon,
  text,
  isLoading,
  isDisabled,
}: {
  text: string;
  icon: ReactNode;
  handler: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
}) => {
  return (
    <ListItemButton
      disabled={isDisabled}
      onClick={handler}
      sx={{
        gap: "6px",
        justifyContent: "flex-start",
        color: "#1C3C6C",
        borderRadius: "4px",
        padding: "4px 8px",
      }}
    >
      <ListItemIcon sx={{ minWidth: "10px" }}>
        {isLoading ? (
          <CircularProgress size={20} sx={{ color: "inherit" }} />
        ) : (
          icon
        )}
      </ListItemIcon>
      <ListItemText
        primary={
          <Typography fontWeight={500} fontSize="14px" lineHeight="20px">
            {text}
          </Typography>
        }
      />
    </ListItemButton>
  );
};
